import request from "@utils/request";
/**
 * 门店详情；
 */
export function getMerchantDetail(data = {}) {
  return request.post("/merchant/detail", data, { login: false });
}
/**
 * 获取线下门店商品分类；
 */
export function getOffLineCategory(mid, tag) {
  return request.get(
    "/merchant/category/" + mid + "?tag=" + tag,
    {},
    { login: false }
  );
}
/**
 * 获取商户详细信息；
 */
export function getMerInfo() {
  return request.get("/mer_info", {}, { login: false });
}
